module.exports = __webpack_public_path__ + "static/media/sia-new-displaced.f909ea98.png";